<div class="promotions-page">
  <!-- =========================================
       TARJETA DE PUNTOS
  ========================================== -->
  <section class="points-section">
    <div class="tarjeta">
      <img class="tarjeta-fondo" src="../../assets/logos-nina/nina2_tarjeta_puntos2.png" alt="Tarjeta de puntos Nina">
      <!-- USUARIO NO LOGUEADO -->
      <div class="tarjeta-no-cuenta" *ngIf="!tokenSSLoged">
        <p class="tarjeta-invitacion">
          Acumula puntos y disfruta
          <br>
          beneficios exclusivos
        </p>
        <button class="tarjeta-boton" type="button" (click)="login()">
          ACCEDE O CREA UNA CUENTA
        </button>
      </div>
      <!-- USUARIO LOGUEADO -->
      <div class="tarjeta-si-cuenta" *ngIf="tokenSSLoged && userData != null && userPointsData != null">
        <!-- DATOS EN EL RECUADRO BLANCO SUPERIOR DERECHO -->
        <div class="tarjeta-datos">
          <p class="tarjeta-nombre">
            {{ userData.names }}
          </p>
          <p>
            {{ userData.last_name }}
            {{ userData.last_name2 }}
          </p>
          <p class="tarjeta-puntos">
            Puntos:
            <span>{{ userPointsData.puntos }}</span>
          </p>
        </div>
        <!-- CÓDIGO DE BARRAS -->
        <div class="tarjeta-barcode-container">
          <ngx-barcode class="tarjeta-barcode" [bc-format]="'CODE128'" [bc-value]="userPointsData.numeroTarjeta"
            [bc-width]="1.25" [bc-height]="30" [bc-display-value]="true" [bc-font-size]="16" [bc-margin]="0">
          </ngx-barcode>
        </div>
      </div>
    </div>
  </section>
  <!-- =========================================
       PROMOCIONES
  ========================================== -->
  <section class="promotions-section" *ngIf="promotions.length > 0">
    <div class="promotion" *ngFor="let promotion of promotions">
      <div class="promotion-banner">
        <img [src]="promotion.urlBannerW || defImgBanner" [defaultImage]="defImgBanner"
          [alt]="promotion.titulo || 'Promoción Nina'">
      </div>
      <div class="promotion-content">
        <h2 class="promotion-title">
          {{ promotion.titulo }}
        </h2>
        <button class="promotion-button" type="button" (click)="promocionSelected(promotion)">
          CANJEAR
        </button>
      </div>
    </div>
  </section>
  <!-- =========================================
       SIN PROMOCIONES
  ========================================== -->
  <section class="no-promotions" *ngIf="promotions.length == 0">
    <img src="../../../assets/img/nina_no_promocion.png" alt="No hay promociones" class="no-promotions-image">
    <h2 class="text-title">
      No hay promociones vigentes
    </h2>
    <p class="text-subtitle">
      Actualmente no hay promociones vigentes, estamos trabajando
      para traerte nuevas promociones.
    </p>
  </section>
</div>